import React, { useRef, useCallback } from 'react'

import { Form } from 'components'

import WizardStep from './WizardStep'

export const WizardStepForm = ({ data, onNext, isLoading, children, ...props }) => {
  const ref = useRef()

  const onError = useCallback((errors, e) => {
    if (errors) {
      for (let obj = errors; obj; obj = obj[Object.keys(obj)[0]]) {
        if (obj.hasOwnProperty('ref')) {
          const node = document.getElementsByName(obj.ref.name)[0]
          if (node) {
            node.scrollIntoView()
          }
          break
        }
      }
    }
  }, [])

  return (
    <WizardStep {...props} onNext={() => ref.current.submit()}>
      <Form ref={ref} data={data} onSubmit={onNext} onError={onError} isLoading={isLoading}>
        {children}
      </Form>
    </WizardStep>
  )
}

export default WizardStepForm
